import { Controller } from "@hotwired/stimulus"
import flatpickr from 'flatpickr'
import { French } from "flatpickr/dist/l10n/fr.js"

// Connects to data-controller="datepicker"
export default class extends Controller {
  static values = {
    minDate: String,
    maxDate: String,
    defaultDate: String,
    classlist: String,
    hideYear: Boolean
  }

  connect() {
    // replaceAll is needed because Firefox receives the date strings with double quotes (like: '"2023-01-01"'), which is not valid for the Date constructor
    const inputElement = this.element.getElementsByTagName('input')[0]
    const id = inputElement.id
    // Pass the raw "Y-m-d" strings (not JS Dates): flatpickr parses them at local midnight, matching
    // how `enable` and the selected date are parsed. `new Date("Y-m-d")` is parsed as UTC, so in a
    // positive-offset timezone (e.g. CET) minDate becomes 01:00 local — which pushes a boundary date
    // (e.g. the start_date, parsed at 00:00) just *below* minDate, making it unselectable.
    const minDate = (this.minDateValue !== '') ? this.minDateValue.replaceAll('"', '') : null
    const maxDate = (this.maxDateValue !== '') ? this.maxDateValue.replaceAll('"', '') : null
    const defaultDate = (this.defaultDateValue !== '') ? this.defaultDateValue.replaceAll('"', '') : null
    let flatpickrOptions = {
      inline: true,
      allowInput: true,
      locale: French,
      minDate: minDate,
      maxDate: maxDate,
      defaultDate: defaultDate,
    }
    if (this.element.dataset.datepickerEnableDates ) {
      flatpickrOptions['enable'] = this.element.dataset.datepickerEnableDates.split(' ');
    }
    const fp = flatpickr(`#${id}`, flatpickrOptions); // flatpickr

    // The `defaultDate` option is not reliably honored alongside `enable` (and a type="date" input):
    // the calendar can open on the current month with nothing selected. Force both the selection and
    // the navigation so the calendar selects the default date AND opens on its month.
    if (defaultDate) {
      fp.setDate(defaultDate, false);
      fp.jumpToDate(defaultDate);
    }

    if (this.hideYearValue === true) {
      fp.currentYearElement.classList.add('d-none');
    }

    this.onReady(null, null, fp);
  }

  setDate(event) {
    // Use currentTarget which is the element the event listener is attached to (the button)
    const buttonElement = event.currentTarget;
    const dateString = buttonElement?.dataset?.date;

    if (dateString && this.flatpickrInstance) {
      // Pass the string so flatpickr parses it with its own (local) date format, matching the
      // `enable` list. A UTC-parsed `new Date(dateString)` can shift a day onto a disabled date,
      // which flatpickr rejects — snapping the calendar back to today instead of the target.
      this.flatpickrInstance.setDate(dateString, true);
    }
  }

  onReady(_, __, fp) {
    if (this.classlistValue !== '') {
      this.classlistValue.split(" ").forEach(function (className) {
        fp.calendarContainer.classList.add(className);
      });
    }

    // Store the flatpickr instance for later use
    this.flatpickrInstance = fp;
  }
}
